import { render, staticRenderFns } from "./add.vue?vue&type=template&id=ce5ddc9e&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=ce5ddc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5ddc9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce5ddc9e')) {
      api.createRecord('ce5ddc9e', component.options)
    } else {
      api.reload('ce5ddc9e', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=ce5ddc9e&scoped=true&", function () {
      api.rerender('ce5ddc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operate/siteTotal/dialog/add.vue"
export default component.exports